import { createFileRoute } from '@tanstack/react-router';

interface ArtworksSearch {
  status?: string;
}

export const Route = createFileRoute('/gallery/artworks/')({
  validateSearch: (search: Record<string, unknown>): ArtworksSearch => ({
    status: typeof search.status === 'string' && search.status !== '' ? search.status : undefined,
  }),
});
